<template>
  <div class="koneko-dashboard-workload">
    <v-alert v-if="loading" type="info" outlined dense class="mb-3">
      Loading budget snapshot…
    </v-alert>
    <v-alert v-if="loadError" type="error" outlined dense class="mb-3">
      {{ loadError }}
    </v-alert>
    <dev-api-wiring-hint :force="Boolean(loadError)" />
    <v-alert
      v-if="!loading && isFutureCalendarMonth"
      type="info"
      outlined
      dense
      class="mb-3"
    >
      <strong>{{ calendarMonthDisplayTitle }}</strong> has not started — expect
      zero logged hours until timesheets exist for that month.
    </v-alert>

    <koneko-a-month-navigator
      v-if="!loading && !loadError"
      :title="calendarMonthDisplayTitle"
      :show-this-month-hint="isViewingCurrentCalendarMonth"
      @prev="goToPreviousKonekoMonthEmbedded"
      @next="goToNextKonekoMonthEmbedded"
    />

    <div
      v-if="!loading && !loadError"
      class="d-flex flex-wrap align-center mb-3"
      style="gap: 12px"
    >
      <span class="caption grey--text text--darken-1">
        Last updated {{ lastUpdatedCompact }}
      </span>
      <v-btn
        small
        outlined
        color="primary"
        :loading="loading"
        @click="refreshNow"
      >
        Refresh data
      </v-btn>
    </div>

    <slot
      v-if="!loading"
      :projectBudgets="projectBudgets"
      :projectBudgetSnapshotRows="projectBudgetSnapshotRows"
      :visibleMembers="visibleMembers"
      :calendarMonthKey="calendarMonthKey"
      :monthElapsedPercent="monthElapsedPercent"
      :weekLabel="weekLabel"
      :formatHoursCell="formatHoursCell"
      :setProjectSnapshotBudgetBaselineForProject="
        setProjectSnapshotBudgetBaselineForProject
      "
      :memberHeadlineHours="memberHeadlineHours"
      :memberHeadlineLimitClause="memberHeadlineLimitClause"
      :memberHasUnknownProject="memberHasUnknownProject"
      :memberBreakdownMonthTotalLabel="memberBreakdownMonthTotalLabel"
      :memberBreakdownCapTotalLabel="memberBreakdownCapTotalLabel"
      :personalAllocationOverBudget="personalAllocationOverBudget"
      :budgetStatusTextClass="budgetStatusTextClass"
      :konekoProjectOptions="konekoProjectOptions"
      :timesheetReassignSavingId="timesheetReassignSavingId"
      :canReassignKonekoEntry="canReassignKonekoEntry"
      :reassignKonekoTimesheetEntry="reassignKonekoTimesheetEntry"
      :showKonekoReassignUi="showKonekoReassignUi"
    ></slot>
  </div>
</template>

<script>
import konekoAWorkloadMixin from "@/mixins/konekoAWorkloadMixin";
import DevApiWiringHint from "@/components/DevApiWiringHint.vue";
import KonekoAMonthNavigator from "@/components/Koneko/KonekoAMonthNavigator.vue";
import {
  defaultKonekoCalendarMonthKey,
  konekoABudgetSubmissionOpensDay,
} from "@/config/konekoAConfig";

export default {
  name: "KonekoADashboardWorkload",
  components: {DevApiWiringHint, KonekoAMonthNavigator},
  mixins: [konekoAWorkloadMixin],
  props: {
    /** NekoHR username key from team list (View as), or empty = signed-in user for Member Breakdown. */
    embeddedViewAsUsername: {type: String, default: ""},
  },
  data() {
    return {
      dashboardEmbedFlag: true,
      budgetSubmissionOpensDay: konekoABudgetSubmissionOpensDay,
    };
  },
  computed: {
    lastUpdatedCompact() {
      if (!this.lastUpdatedAt) return "—";
      try {
        return new Date(this.lastUpdatedAt).toLocaleString();
      } catch {
        return String(this.lastUpdatedAt);
      }
    },
  },
  async mounted() {
    this.selectedMonthKey = defaultKonekoCalendarMonthKey();
    this.loadMonthBudgetDraft();
    await this.loadKonekoAData();
  },
  methods: {
    goToPreviousKonekoMonthEmbedded() {
      this.goToPreviousKonekoMonth();
      this.onMonthChangeEmbedded();
    },
    goToNextKonekoMonthEmbedded() {
      this.goToNextKonekoMonth();
      this.onMonthChangeEmbedded();
    },
    onMonthChangeEmbedded() {
      this.loadMonthBudgetDraft();
      this.loadKonekoAData(true);
    },
  },
};
</script>

<style scoped>
.koneko-dashboard-workload {
  width: 100%;
}
</style>
